export const SAVE_TEST = '@@TEST/SAVE_TEST';
export const GO_TO_USER_PAGE = '@@APP/SET_ACTIVE_FOOTER_MENU';

export const actionCreators = {
    saveTest: (result) => {
        return ({
        type: SAVE_TEST, 
        payload: result
    })},
    goToUserPage: () => ({
        type: GO_TO_USER_PAGE,
        payload: 1
    })
};
